import { ModelModuleChip } from '#components/model-module-chip/model-module-chip.js';

import type { DesignModels } from '@cadstrom/sigma-engine-shared';

export interface ModelModuleMarkdownItemProps {
	moduleRef?: string;
	signal?: DesignModels.SignalId;
}

/**
 * Renders a markdown module reference with the same interactive chip used by CAD model views.
 */
export function ModelModuleMarkdownItem(props: ModelModuleMarkdownItemProps) {
	if (props.moduleRef === undefined) {
		return null;
	}

	return (
		<span className='mx-0.5 inline-flex items-center align-middle isolate'>
			<ModelModuleChip moduleReferenceDesignator={props.moduleRef} signalId={props.signal} />
		</span>
	);
}
